import { piniaInstance } from '../js/global';
import { defineStore } from 'pinia';


export const useSettingsStore = defineStore("settings", {
  state: () => ({
    defaultCurrency: "ARS",
    exchangeRate: 1,
    freeShippingMount: 10000,
    minPurchaseMount: 0,
    defaultImage: `/dist/images/not-image.svg`,
    //area admin
    defaultCurrencyAdmin: "ARS"
  }),
  getters: {
    getCurrency(state) {
      return {
        'currency': this.defaultCurrency,
        'exchange_rate': this.exchangeRate
      }
    },
    getCurrencyAdmin(state) {
      return {
        'currency': this.defaultCurrencyAdmin
      }
    },
    getMinPurchaseMount(state){
      return this.minPurchaseMount;
    }
  },
  actions: {
    async getData() {
      try {
        await fetch('/api/settings/defaults')
          .then((response) => { return response.json(); })
          .then((data) => {
            this.defaultCurrency = data.default_currency.value;
            this.exchangeRate = data.default_currency_exchange_rate.value;
            this.defaultCurrencyAdmin = data.default_currency_admin.value;
            this.minPurchaseMount = data.min_purchase_mount;
            this.show_prices_topsales_offers= data.show_prices_topsales_offers;
          });
      }
      catch (error) {
        alert(error)
        console.log(error)
      }
    }
  }
})(piniaInstance);
